import React from "react";

function Brokers() {
  return (
    <section
      className="service_section pb-5"
      data-aos="fade-up"
      data-aos-easing="linear"
      data-aos-duration="400"
    >
      <div className="circle_one"></div>
      <div className="circle_two"></div>
      <div className="container">
        <div className="section_title light centred">
          <h2>Unlock Benefits by Logging In or Creating an Account</h2>
          <p style={{ color: "#fff" }} className="mt-3">
            Use the links below to log in or open an account with trusted
            platforms and gain exclusive <br />
            benefits for your financial journey.
          </p>
        </div>

        <div className="row">
          {/* Bigul Block */}
          <div className="col-xl-6 col-md-6 col-sm-12">
            <div
              className="service_block_one other_login"
              data-aos="fade-up"
              data-aos-duration="500"
            >
              <div className="login-head">
                <img
                  src="/images/logo-images/bigul-logo.png"
                  alt="Bigul Logo"
                  className="bg-white"
                  style={{ width: "20%", height: "100%" }}
                />
                <h3 className="text-2xl font-semibold">Bigul</h3>
              </div>
              <div className="login-btn">
                <a
                  href="https://bigul.co/sso-login"
                  target="_blank"
                  rel="noreferrer"
                  className="btn_style_one"
                >
                  Login
                </a>
                <a
                  href="https://bigul.co/open-account?r=t7hrecu"
                  target="_blank"
                  rel="noreferrer"
                  className="btn_style_one"
                >
                  Open Account
                </a>
              </div>
            </div>
          </div>

          {/* Octafx Block */}
          <div className="col-xl-6 col-md-6 col-sm-12">
            <div
              className="service_block_one other_login"
              data-aos="fade-up"
              data-aos-duration="550"
              data-aos-delay="100"
            >
              <div className="login-head">
                <img
                  src="/images/logo-images/octafx-logo.jpg"
                  alt="Octafx Logo"
                  className="bg-white"
                  style={{ width: "20%", height: "100%" }}
                />
                <h3 className="text-2xl font-semibold">Octafx</h3>
              </div>
              <div className="login-btn">
                <a
                  href="https://my.elev8.com/login/?back=%2F&fromFront=1"
                  target="_blank"
                  rel="noreferrer"
                  className="btn_style_one"
                >
                  Login
                </a>
                <a
                  href="https://my.octafx.com/open-account/?refid=ib540270"
                  target="_blank"
                  rel="noreferrer"
                  className="btn_style_one"
                >
                  Open Account
                </a>
              </div>
            </div>
          </div>

          {/* Exness Block */}
          <div className="col-xl-6 col-md-6 col-sm-12">
            <div
              className="service_block_one other_login"
              data-aos="fade-up"
              data-aos-duration="600"
              data-aos-delay="200"
            >
              <div className="login-head">
                <img
                  src="/images/logo-images/Exness_Logo.jpg"
                  alt="Exness Logo"
                  style={{ width: "15%", height: "100%" }}
                />
                <h3 className="text-2xl font-semibold">
                  Exness Technologies LTD
                </h3>
              </div>
              <div className="login-btn">
                <a
                  href="https://www.exness.com/metatrader-5/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn_style_one"
                >
                  Login
                </a>
                <a
                  href="https://one.exnesstrack.org/a/8ws9gzq6ov"
                  target="_blank"
                  rel="noreferrer"
                  className="btn_style_one"
                >
                  Open Account
                </a>
              </div>
            </div>
          </div>

          {/* Alice Blue Block */}
          <div className="col-xl-6 col-md-6 col-sm-12">
            <div
              className="service_block_one other_login"
              data-aos="fade-up"
              data-aos-duration="650"
              data-aos-delay="300"
            >
              <div className="login-head">
                <img
                  src="/images/logo-images/alice-blue-logo.png"
                  alt="Alice-Blue Logo"
                  className="bg-white"
                  style={{ width: "20%", height: "100%" }}
                />
                <h3 className="text-2xl font-semibold">Alice Blue Online</h3>
              </div>
              <div className="login-btn">
                <a
                  href="https://ant.aliceblueonline.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn_style_one"
                >
                  Login
                </a>
                <a
                  href="https://ekyc.aliceblueonline.com/?source=WMUM1772"
                  target="_blank"
                  rel="noreferrer"
                  className="btn_style_one"
                >
                  Open Account
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Brokers;
